/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RecommendedItemFragment = {
  readonly __typename?: 'LineItemRecommendation';
  readonly id: string;
  readonly name: string;
  readonly recommendationType: Types.RecommendationType;
  readonly ingredientIds: ReadonlyArray<string>;
};

export type LineItemRecommendationsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type LineItemRecommendationsQuery = {
  readonly __typename?: 'Query';
  readonly lineItemRecommendations: ReadonlyArray<{
    readonly __typename?: 'LineItemRecommendation';
    readonly id: string;
    readonly name: string;
    readonly recommendationType: Types.RecommendationType;
    readonly ingredientIds: ReadonlyArray<string>;
  }>;
};

export const lineItemRecommendationsQueryMock: ExecutionResult<LineItemRecommendationsQuery> =
  {
    data: {
      lineItemRecommendations: [
        {
          id: 'Hello World',
          name: 'Hello World',
          recommendationType: 'HISTORICAL',
          ingredientIds: ['Hello World', 'Hello World'],
        },
        {
          id: 'Hello World',
          name: 'Hello World',
          recommendationType: 'HISTORICAL',
          ingredientIds: ['Hello World'],
        },
        {
          id: 'Hello World',
          name: 'Hello World',
          recommendationType: 'HISTORICAL',
          ingredientIds: ['Hello World', 'Hello World'],
        },
      ],
    },
  };
export const RecommendedItemFragmentDoc = gql`
  fragment RecommendedItem on LineItemRecommendation {
    id
    name
    recommendationType
    ingredientIds
  }
`;
export const LineItemRecommendationsDocument = gql`
  query LineItemRecommendations {
    lineItemRecommendations {
      ...RecommendedItem
    }
  }
  ${RecommendedItemFragmentDoc}
`;

export function useLineItemRecommendationsQuery(
  options?: Omit<
    Urql.UseQueryArgs<LineItemRecommendationsQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    LineItemRecommendationsQuery,
    LineItemRecommendationsQueryVariables
  >({ query: LineItemRecommendationsDocument, ...options });
}
